export default __webpack_public_path__ + "static/media/Scott_Tessman_Resume.df5afe1c.pdf";